import { LongAnimationTask } from "../app/messages.gen";
export default function (app, opts) {
    if (!opts.longTasks || !('PerformanceObserver' in window)) {
        return;
    }
    const onEntry = (entry) => {
        app.send(LongAnimationTask(entry.name, entry.duration, entry.blockingDuration, entry.firstUIEventTimestamp, entry.startTime, JSON.stringify(entry.scripts ?? [])));
    };
    const observer = new PerformanceObserver((entryList) => {
        entryList.getEntries().forEach((entry) => {
            if (entry.entryType === 'long-animation-frame') {
                onEntry(entry);
            }
        });
    });
    app.attachStartCallback(() => {
        performance.getEntriesByType('long-animation-frame').forEach((lat) => {
            onEntry(lat);
        });
        observer.observe({
            entryTypes: ['long-animation-frame'],
        });
    });
    app.attachStopCallback(() => {
        observer.disconnect();
    });
}
